import { render, staticRenderFns } from "./contact-info-box.vue?vue&type=template&id=638c76fe&lang=pug&"
import script from "./contact-info-box.vue?vue&type=script&lang=js&"
export * from "./contact-info-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports